import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'

import appReducer from './reducers/app-reducer'

const initialState = {}

const middleware = [thunk]

const store = createStore(appReducer, initialState, applyMiddleware(...middleware))

export default store



// WEBPACK FOOTER //
// ./src/store.js